import axios from 'axios'
import {URL_BASE} from '@/api/url.js'
const request = axios.create({
    baseURL: URL_BASE,
    timeout: 60000, //改成60s
})

// 请求拦截器
request.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = config.headers['Content-Type'] ? config.headers['Content-Type'] : 'application/json'
        config.headers.Accept = '*/*'
        config.headers['Authorization'] = sessionStorage.getItem('access_token') ? 'bearer ' + sessionStorage.getItem('access_token') : 'bearer';
        config.headers.bizId = 'aeuE2uLpST3uF9NRQkE30w=='
        config.headers.sd = 11
        return config;
    },
    (error) => {
        return Promise.reject(error)
    }
)

// 响应拦截器
request.interceptors.response.use(
    (res) => {
        if (res.status === 200) {
            return res.data
        } else {
            return res.data
        }
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default request
